import React from 'react';

export default function Sprite() {
  return (
    <svg style={{ display: 'none' }} xmlns="http://www.w3.org/2000/svg">
      <symbol id="logout" viewBox="0 0 16 16">
        <path d="M6.3 11.2l1.3 1.3L12 8 7.6 3.6 6.3 4.8l2.3 2.3H0v1.8h8.6l-2.3 2.3zM14.2 0H1.8C.8 0 0 .8 0 1.8v3.6h1.8V1.8h12.4v12.4H1.8v-3.6H0v3.6c0 1 .8 1.8 1.8 1.8h12.4c1 0 1.8-.8 1.8-1.8V1.8c0-1-.8-1.8-1.8-1.8z"/>
      </symbol>
    </svg>
  );
}
